import apiLogin from '@/api/account';
import { getXAPIEnv } from '@/plugins/account';

export default class OneSignalTool {
  static getOneSignalInstance() {
    return window.OneSignal;
  }

  /* Cria uma instancia do OneSignal */
  static async initialize(appId) {
    const oneSignalInstance = await window.initOneSignal(appId);
  }

  /* Verifica a subscrição */
  static async verifySubscription() {
    const hasPermission = await OneSignalTool.hasPermission();
    if (hasPermission) {
      OneSignalTool.subscribe();
    } else {
      OneSignalTool.createSubscribeListener();
    }
  }

  /* Cria um ouvinte para o evento de alteração da subscrição */
  static createSubscribeListener() {
    const oneSignal = OneSignalTool.getOneSignalInstance();

    /* Se necessário, solicita permissão ao navegador */
    oneSignal.registerForPushNotifications();
    const callback = () => {
      const instance = OneSignalTool;
      return (subscribed) => {
        if (subscribed) {
          instance.subscribe();
        }
      };
    };

    oneSignal.on('subscriptionChange', callback());
  }

  /* Subscreve o usuário no Web Push */
  static async subscribe() {
    try {
      const oneSignal = OneSignalTool.getOneSignalInstance();
      const hasPermission = await OneSignalTool.hasPermission();
      const userResponse = await apiLogin.me();
      const user = userResponse.getData({ id: null, name: null });
      if (hasPermission && user && user.id) {
        const environment = getXAPIEnv();
        const userName = user.name;

        await oneSignal.setSubscription(true);
        await oneSignal.setExternalUserId(environment);
        await oneSignal.sendTag('name', userName);
      } else {
        OneSignalTool.unsubscribe();
      }
    } catch (ex) {
      console.log('Não foi possível realizar a assinatura do usuário');
    }
  }

  static async unsubscribe() {
    const oneSignal = OneSignalTool.getOneSignalInstance();
    await oneSignal.setSubscription(false);
    await oneSignal.setExternalUserId('');
  }

  /* Verifica se a App tem permissão para notificações */
  static async hasPermission() {
    const oneSignal = OneSignalTool.getOneSignalInstance();
    const permission = await oneSignal.getNotificationPermission();
    return permission === 'granted';
  }
}
